module.exports = __webpack_public_path__ + "img/pay-wallet.ee0f6bbc.svg";